import { createContext } from "react";
import type { SerialKillerDTO, VictimDTO } from "@shared/contracts";

export type FilterType = "serialkiller" | "unsolved" | "missing";

export type Filter = {
  id: number;
  killerId: string | null;
  color: string;
  visible: boolean;
  type: FilterType;
  from: string | null;
  to: string | null;
  country: string | null;
  region: string | null;
};

export type VictimsAndKillersContextValue = {
  filters: Filter[];
  addFilter: () => void;
  removeFilter: (id: number) => void;
  setFilterColor: (id: number, color: string) => void;
  setFilterVisible: (id: number, visible: boolean) => void;
  setFilterKiller: (id: number, killerId: string | null) => void;
  setFilterType: (id: number, type: FilterType) => void;
  setFilterFrom: (id: number, from: string | null) => void;
  setFilterTo: (id: number, to: string | null) => void;
  setFilterCountry: (id: number, country: string | null) => void;
  setFilterRegion: (id: number, region: string | null) => void;
  clearFilters: () => void;
  importFilters: (filters: Filter[]) => void;
  victimsByFilter: Record<number, VictimDTO[]>;
  loadingByFilter: Record<number, boolean>;
  serialKillerById: Record<string, SerialKillerDTO | undefined>;
  serialKillerLoadingById: Record<string, boolean>;
};

export const VictimsAndKillersContext = createContext<VictimsAndKillersContextValue | undefined>(
  undefined
);
